import { render, staticRenderFns } from "./FormExpiredAndRegistered.vue?vue&type=template&id=438ccfb7&"
import script from "./FormExpiredAndRegistered.vue?vue&type=script&lang=js&"
export * from "./FormExpiredAndRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports